// extracted by mini-css-extract-plugin
module.exports = {"toteItem":"OrderFulfillmentPage_toteItem__2UMqc","itemBlock":"OrderFulfillmentPage_itemBlock__1KBRZ"};